import authApi from 'utils/authApi';

export const login = (data) => {
    return authApi.post('/login', data);
};

export const refreshToken = () => {
    return authApi.get('/refresh-token');
};

export const validateEmail = (data) => {
    return authApi.get('/validate-email', { params: data });
};

export const forgotPassword = (data) => {
    return authApi.get('/forgot-password', { params: data });
};

export const resetPassword = async (data) => {
    const response = await authApi.post('/reset-password', data);
    return response.data;
};
